import React, {useState, useEffect} from "react";
import PageTitle from "components/common/PageTitle";
import TodosWrapper from "components/todos/todos.style";
import ToDoApplication from "components/todos/ToDoApplication";
import { TodosProvider } from "components/todos/context/TodosProvider";

const Todos = () => {
  const [notifications, setNotifications] = useState([])

  useEffect(() => {

    fetch('/service/notifications/show')
    .then(res => res.json())
    .then(data => setNotifications(data))

  }, [])



  return (
    <TodosWrapper>
      <PageTitle
        title="sidebar.todos"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.app"
          },
          {
            name: "sidebar.todos"
          }
        ]}
      />
      {/*<Notification data={notifications}/>*/}
      {/* Todos Provider is context of todos application where all data stored  */}
      <TodosProvider data={notifications}>
        {/*  Root component of todos application  */}
        <ToDoApplication />
      </TodosProvider>
    </TodosWrapper>

    
  );
};

export default Todos;
